import { render, staticRenderFns } from "./GDPRRequest.vue?vue&type=template&id=56f6cd1c&"
import script from "./GDPRRequest.vue?vue&type=script&lang=js&"
export * from "./GDPRRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports